var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paymentSuccess"},[_c('div',{staticClass:"pay_title"},[_c('van-icon',{staticClass:"icon",attrs:{"name":"success"}}),_c('div',[_vm._v(_vm._s(_vm.productName))]),_c('div',[_vm._v("领取成功")])],1),_c('div',{staticClass:"pay_content"},[_vm._v("我们将尽快联系您")])])
}
var staticRenderFns = []

export { render, staticRenderFns }